import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationService } from "src/app/providers/navigation.service";
import { CreatePromotionCampaignComponent } from "../new-v2-component/create-promotion-campaign/create-promotion-campaign.component";
import { ShowTargetsComponent } from "../new-v2-component/show-targets/show-targets.component";
import { DialogService } from "src/app/providers/dialog.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { ApiService } from "src/app/providers/api.service";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
// import { CreatePromotionCampaignComponent } from '../new-v2-component/create-promotion-campaign/create-promotion-campaign.component';
// import { ShowTargetsComponent } from '../new-v2-component/show-targets/show-targets.component';

@Component({
  selector: "sm-promotion-campaign",
  templateUrl: "./promotion-campaign.component.html",
  styleUrls: ["./promotion-campaign.component.scss"],
})
export class PromotionCampaignComponent implements OnInit, OnDestroy {
  loader: boolean = false
  apisub: Subscription
  pageNo:number = 1
  campaignData:any = []
  constructor(
    private dialog: MatDialog,
    private navservice: NavigationService,
    private dialogservice: DialogService,
    private router: Router,
    private route: ActivatedRoute,
    private ls: LoaderServiceService,
    private apiservice: ApiService
  ) {
    this.navservice.hideSidebarAndNav = false;
  
    this.apisub = this.apiservice.apiResult.subscribe(resdata => {
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_GET_ENTITY_WHATSAPP_CAMPAIGN_LIST){
        this.campaignData = []  
        if(resdata.result){
          this.campaignData = resdata.result

          this.campaignData.forEach((element:any) => {
            if(element.campaign_progress == 0){
              element.c_progress = 'New'
            }
            if(element.campaign_progress == 1){
              element.c_progress = 'In progress'
            }
            if(element.campaign_progress == 2){
              element.c_progress = 'Complete'
            }
            if(element.campaign_progress == 3){
              element.c_progress = 'Paused'
            }
            if(element.body.length>=80){
              element.toshowmore=true
            }
          });
        }
        this.ls.showLoader = false
        this.loader = false
      }
      if(resdata.responseType === SM_CONSTANTS.RESULT_API_DELETE_ENTITY_WHATSAPP_CAMPAIGN){
        
        if(resdata.result){
          this.apiservice.getEntityExternalCampaignList(this.entityHash,this.pageNo.toString())
        }
      }
    })
  }
  entityHash: any
  ngOnInit(): void {

    this.route.queryParams.subscribe(data => {
      if(data.entityHash){
        this.entityHash = data.entityHash
        this.loader = true
        this.ls.showLoader = true
        this.apiservice.getEntityExternalCampaignList(this.entityHash,this.pageNo.toString())
      }
    })


  }

   openlink(item:any){
   if (item.external_link && item.external_link !== '' && item.external_link !== 'null') {
    let url = item.external_link.trim();

    // Add https:// if missing
    if (!/^https?:\/\//i.test(url)) {
      url = 'https://' + url;
    }

    

    window.open(url, '_blank');
  }
  }

showmore(item:any){
item.toshowmore=!item.toshowmore
}


  opencreatenew() {

    this.router.navigate(['create-new-campaign'],{relativeTo: this.route, queryParamsHandling: 'preserve'})

    // let data = {

    // }
    // this.dialogservice.openFullScreenDialog(CreatePromotionCampaignComponent, data);
  }

  openshowtarget(item:any) {
    this.ls.showLoader = true
    let data = {
      campaignData:item
    }
    this.dialogservice.openFullScreenDialog(ShowTargetsComponent,data);
  }

  deleteItem(item:any){
     const dialogRef = this.dialog.open(CustomConfirmDialogComponent, {
          // width: "400px",
          data: {
            title: "Alert",
            message: "Are you sure you want to delete this campaign?",
            okbtn: "Yes",
            cancelbtn: "No",
            type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
          },
          disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
          console.log(result);
          if (result) {
            let data = {
              "campaign_hash": item.hash_id,
              "entity_hash": this.entityHash
            }

            this.ls.showLoader = true
            this.apiservice.deleteEntityExternalCampaign(data)
          }
        })
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe()
  }
}
